module.exports = __webpack_public_path__ + "img/free-proxy-list.b578f100.svg";